<template>
  <div class="fb-set-thanks">
    <h1>Oops..</h1>
    <p>
      Something went wrong.
      <a target="_blank" href="https://support.readylxp.com">Contact us.</a>
    </p>
    <div class="fb-actions">
      <md-button @click="goTo('/learner')" class="md-secondary fb-prev">Back to Dashboard</md-button>
      <md-button @click="tryAgain" class="md-raised md-primary fb-next">Try Again!</md-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "FbError",
  props: ["routeName", "nid"],
  data() {
    return {
      page: [],
      id: 0,
    };
  },
  methods: {
    goTo(url) {
      window.location.href = url;
    },
    tryAgain() {
      window.history.back();
    },
  },
  created() {
    this.page = window.location.pathname.split("/")[1];
    this.id = window.location.pathname.split("/")[2];
  },
};
</script>
<style lang="scss" scoped>
.fb-set-thanks {
  .fb-actions {
    padding-top: 80px;
    padding-bottom: 20px;
    .fb-prev {
      color: $blue-active;
      float: left;
      @media all and (min-width: $breakpoint-medium) {
        font-size: 18px;
      }
    }
    .fb-next {
      float: right;
    }
  }
  flex-direction: column;
  display: flex;
  justify-content: flex-end;
  color: rgb(60, 60, 60);
  font-family: $font-filson-soft;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  h1 {
    color: rgb(60, 60, 60);
    font-family: $font-filson-soft;
    font-size: 36px;
    line-height: 54px;
  }
  a {
    color: rgb(60, 60, 60);
    &:hover {
      color: rgb(60, 60, 60);
    }
  }
  background-image: url("../assets/error.svg");
  min-height: 660px;
  border-radius: 20px;
  margin: 0px;
  margin-top: 16px;
  width: auto;
  background-position: center center;
  background-repeat: no-repeat;
}
</style>
